import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLang } from '../hooks';
import { getVideos, getYoutubeEmbedUrl, getYoutubeThumbnailUrl, type Video } from '../services/api/videos';
import './VideosPage.css';

export default function VideosPage() {
  const { t } = useTranslation();
  const locale = useLang().lang;
  const [videos, setVideos] = useState<Video[]>([]);
  const [loading, setLoading] = useState(true);
  const [playing, setPlaying] = useState<string | null>(null);

  useEffect(() => {
    getVideos()
      .then(setVideos)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-loading">{t('common.loading')}</div>;

  return (
    <div className="videos-page page">
      <h1 className="videos-page__title">{t('nav.videos')}</h1>
      <div className="videos-page__grid">
        {videos.map((v) => (
          <div key={v.id} className="video-card">
            {playing === v.id ? (
              <>
                <div className="video-card__embed-wrap">
                  <iframe
                    src={getYoutubeEmbedUrl(v.youtube_url) + '?autoplay=1'}
                    title={locale === 'th' && v.title_th ? v.title_th : v.title_en}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="video-card__body">
                  <p className="video-card__title">{locale === 'th' && v.title_th ? v.title_th : v.title_en}</p>
                  <button type="button" onClick={() => setPlaying(null)} className="video-card__close">Close</button>
                </div>
              </>
            ) : (
              <>
                <button type="button" onClick={() => setPlaying(v.id)} className="video-card__thumb-wrap">
                  <img src={getYoutubeThumbnailUrl(v.youtube_url)} alt="" className="video-card__thumb" />
                  <span className="video-card__play-icon">▶</span>
                </button>
                <div className="video-card__body">
                  <p className="video-card__title">{locale === 'th' && v.title_th ? v.title_th : v.title_en}</p>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
      {videos.length === 0 && <p className="page-empty">No videos yet.</p>}
    </div>
  );
}
